import logoFull from "@/assets/logo-full.svg" with { type: "text" };
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

/**
 * The wide Nyteca wordmark, owl plus lettering.
 *
 * Inlined instead of `<img src>`: the file carries `fill="currentColor"`, and an
 * `<img>` would always paint it black. Inline it takes the surrounding text
 * colour and works in both themes from one file.
 *
 * The caller sets the height (`className="h-14"`), the mark keeps its aspect.
 */
export function BrandWordmark({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <span
      role="img"
      aria-label={t("common.appName")}
      className={cn(
        "block [&>svg]:block [&>svg]:h-full [&>svg]:w-auto",
        className
      )}
      dangerouslySetInnerHTML={{ __html: logoFull }}
    />
  );
}
